export default __webpack_public_path__ + "locales/ja-JP/BackupCodesDialog.json?hash=61d633b88c98d74f4d6b28da233203f7";